import { setRouterHistory } from '@minecraft.utils';
import { environment } from 'config/environment';

export default setRouterHistory({
  basename: environment.BASE_NAME,
  // empty function to override default Browser's prompt
  getUserConfirmation: () => undefined,
});
